import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RJobCategory } from '../job-category/r-job-category-area.action';
import { RJobRoutineAction } from './r-job-routine.action';
import { ResetStateDefaults } from '../../../base-action-class.model';

interface RJobRoutineXsStateModel {
  viewOrgJobRoutine: string;
  createOrgJobRoutine: string;
  editOrgJobRoutine: string;
  deleteOrgJobRoutine: string;

}

const getDefaults = (): RJobRoutineXsStateModel => ({
  viewOrgJobRoutine: null,
  createOrgJobRoutine: null,
  editOrgJobRoutine: null,
  deleteOrgJobRoutine: null

});

@State<RJobRoutineXsStateModel>({
  name: 'rJobRoutine',
  defaults: getDefaults()
})
@Injectable()
export class RJobRoutineXsState {

  //region SELECTOR
  @Selector()
  static canEditRoutine(state: RJobRoutineXsStateModel): boolean {
    return state.editOrgJobRoutine != null;
  }

  @Selector()
  static canDeleteRoutine(state: RJobRoutineXsStateModel): boolean {
    return state.deleteOrgJobRoutine != null;
  }

  @Selector()
  static hasViewOrgJobRoutinePrivilege(state: RJobRoutineXsStateModel): boolean {
    return state.viewOrgJobRoutine != null;
  }

  @Selector()
  static hasCreateOrgJobRoutinePrivilege(state: RJobRoutineXsStateModel): boolean {
    return state.createOrgJobRoutine != null;
  }

  @Selector()
  static hasEditOrgJobRoutinePrivilege(state: RJobRoutineXsStateModel): boolean {
    return state.editOrgJobRoutine != null;
  }

  @Selector()
  static hasDeleteOrgJobRoutinePrivilege(state: RJobRoutineXsStateModel): boolean {
    return state.deleteOrgJobRoutine != null;
  }

  //endregion

  //region ACTIONS
  @Action(RJobRoutineAction.SetJobRoutinePrivileges)
  public setJobRoutinePrivileges(ctx: StateContext<RJobRoutineXsStateModel>, action: RJobCategory.SetJobCategoryPrivileges) {
    const state = ctx.getState();
    const jobRoutinePrivileges = [...action.activeUserRightInfoDtoModel.jobRoutinePrivileges];

    //find user privilege data model
    const viewOrgJobRoutine = jobRoutinePrivileges.find(id => id === UserPrivilegeEnum.VIEW_JOB_ROUTINE);
    const createOrgJobRoutine = jobRoutinePrivileges.find(id => id === UserPrivilegeEnum.CREATE_JOB_ROUTINE);
    const editOrgJobRoutine = jobRoutinePrivileges.find(id => id === UserPrivilegeEnum.EDIT_JOB_ROUTINE);
    const deleteOrgJobRoutine = jobRoutinePrivileges.find(id => id === UserPrivilegeEnum.DELETE_JOB_ROUTINE);

    //set the state
    ctx.setState({
      ...state,
      viewOrgJobRoutine: viewOrgJobRoutine,
      createOrgJobRoutine: createOrgJobRoutine,
      editOrgJobRoutine: editOrgJobRoutine,
      deleteOrgJobRoutine: deleteOrgJobRoutine
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RJobRoutineXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }
}
